﻿
angular.module("fliptoWeb")
    .controller("PartnerPortalSignupCtrl",
        [
            "$scope", "ApiService", "$analytics", "PartnerService", "$location",
            function ($scope, ApiService, $analytics, PartnerService, $location) {
                "use strict";

                enum Sections {
                    YourSelf = 1,
                    WhoYouIntroduce = 2,
                    Complete = 3
                }

                var vm = this;

                vm.activeSection = Sections.YourSelf;
                vm.yourSelf = {};
                vm.introductionTarget = {};

                var trackingInfo = {
                    submitForm: {
                        eventName: "submitted partner sign up form",
                        eventProperties: {
                            category: "partner sign ups",
                            label: "partners page sign up"
                        }
                    },
                    submitSuccess: {
                        eventName: "successful partner sign up form submit",
                        eventProperties: {
                            category: "partner sign ups",
                            label: "partners page sign up"
                        }
                    },
                    submitFail: {
                        eventName: "failed partner sign up form submit",
                        eventProperties: {
                            category: "partner sign ups",
                            label: "partners page sign up"
                        }
                    },
                    modalAbandon: {
                        submitted: "closed modal after partner sign up form submit",
                        abandon: "hard abandoned partner sign up"
                    }
                };
                vm.processingRequest = false;

                vm.hasBeenSubmitted = false;


                vm.submitYourSelfForm = () => {
                    vm.activeSection = Sections.WhoYouIntroduce;
                };

                vm.makeAnotherIntro = () => {
                    vm.introductionTarget = {};
                    vm.activeSection = Sections.WhoYouIntroduce;
                };

                vm.submitWhoYouIntroduceForm = () => {
                    this.errorMessage = "";
                    this.processingRequest = true;

                    $analytics.eventTrack(trackingInfo.submitForm.eventName, trackingInfo.submitForm.eventProperties);

                    let leadData = {
                        First: vm.introductionTarget.firstName,
                        Last: vm.introductionTarget.lastName,
                        Email: vm.introductionTarget.email,
                        Company: vm.introductionTarget.hotelName,
                        Description: vm.introductionTarget.notes,
                        ExtendedData: [
                            { Key: "Partner.First", Value: vm.yourSelf.firstName },
                            { Key: "Partner.Last", Value: vm.yourSelf.lastName },
                            { Key: "Partner.Email", Value: vm.yourSelf.email },
                            { Key: "Partner.Company", Value: PartnerService.getName() },
                            { Key: "Source Url", Value: $location.absUrl() }
                        ]
                    };

                    var analyticsData = ((obj) => {
                        var dataObj = {};
                        for (let i in obj) {
                            if (obj.hasOwnProperty(i) && i !== "ExtendedData") {
                                dataObj[i] = obj[i];
                            } else if (obj.hasOwnProperty(i) && i === "ExtendedData") {
                                angular.forEach(obj[i],
                                    item => {
                                        dataObj[item.Key] = item.Value;
                                    });
                            }
                        }
                        return dataObj;
                    })(leadData);

                    $analytics.setUsername(leadData.Email || leadData.First + " " + leadData.Last);
                    $analytics.setUserProperties(analyticsData);

                    ApiService.PartnersPortalSignup_Post(leadData)
                        .then(response => {
                            if (response.data.Success) {
                                $analytics.eventTrack(trackingInfo.submitSuccess.eventName,
                                    trackingInfo.submitSuccess.eventProperties);
                                vm.hasBeenSubmitted = true;
                                vm.activeSection = Sections.Complete;
                            } else {
                                $analytics.eventTrack(trackingInfo.submitFail.eventName,
                                    trackingInfo.submitFail.eventProperties);
                                vm.errorMessage = response.data.Message;
                            }
                            vm.processingRequest = false;

                        });

                };

            }
        ]);